import React, { useContext } from 'react';

import { deleteSprint, updateSprint } from '../../services/sprints.service';

import { Context } from '../../providers/global-context.provider';
import { ProjectsContext } from '../../providers/projects-context.provider';
import { SprintsContext } from '../../providers/sprints-context.provider';
import { IssuesContext } from '../../providers/issues-context.provider';

import ModalContainer from '../modal-container';
import SprintForm from '../update-sprint-form';
import DeleteButton from '../button-delete';
import SubmitButton from '../button-submit';
import { getCookie } from '../../utils/cookie';

const EditSprintModal = () => {
	const { toggleModalIsOpen } = useContext(Context);
	const { currentProject, saveCurrentProject } = useContext(ProjectsContext);
	const { backlogIssuesCollections, updateBacklogIssues } = useContext(IssuesContext);
	const { currentSprint, toggleUpdatingSprint, updatingSprint } = useContext(SprintsContext);

	const handleUpdateSprint = async (sprint) => {
		const { Title, Goal, StartDate, EndDate, BaleId } = sprint;
		const token = getCookie('x-auth-token');

		try {
			await updateSprint(currentProject.Id, token, currentSprint.Id, { Title, Goal, StartDate, EndDate, BaleId });
			let newCollection = JSON.parse(JSON.stringify(backlogIssuesCollections));
			const sprintIndex = newCollection
				.map(function(x) {
					return x.Id;
				})
				.indexOf(currentSprint.Id);
			let sprintToUpdate = newCollection[sprintIndex];
			sprintToUpdate = {
				...sprintToUpdate,
				Title: sprint.Title,
				StartDate: sprint.StartDate,
				EndDate: sprint.EndDate,
				Goal: sprint.Goal,
				BaleId: sprint.BaleId
			};
			newCollection.splice(sprintIndex, 1, sprintToUpdate);
			updateBacklogIssues(newCollection);
			return true;
		} catch (error) {
			return false;
		}
	};

	const handleClose = () => {
		toggleUpdatingSprint();
		toggleModalIsOpen();
	};

	const handleDeleteSprint = async (e) => {
		e.preventDefault();
		const token = getCookie('x-auth-token');

		try {
			await deleteSprint(currentProject.Id, token, currentSprint.Id);
			let newCollection = JSON.parse(JSON.stringify(backlogIssuesCollections));
			newCollection = newCollection.filter((x) => x.Id !== currentSprint.Id);
			updateBacklogIssues(newCollection);
			saveCurrentProject({ ...currentProject, activeSprintId: null });
			handleClose();
			return true;
		} catch (error) {
			return false;
		}
	};

	const successFunc = () => {
		toggleUpdatingSprint();
	};

	return (
		<ModalContainer onClose={handleClose} show={updatingSprint} addBgColor="bg-black bg-opacity-25">
			<SprintForm
				handleUpdateSprint={handleUpdateSprint}
				showDateInputs={currentSprint.StartDate}
				successFunc={successFunc}
			>
				<div className="flex md:mt-4 mt-6">
					<DeleteButton handleDelete={handleDeleteSprint} />
					<SubmitButton left="ml-6">ویرایش</SubmitButton>
				</div>
			</SprintForm>
		</ModalContainer>
	);
};

export default EditSprintModal;
